
import React, { FC, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

interface SuggestHealthPlanModalProps {
    show: boolean
    onClose: () => void
}

const SuggestHealthPlanModal: FC<SuggestHealthPlanModalProps> = ({
    show,
    onClose,
}) => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [planName, setPlanName] = useState('')
    const [website, setWebsite] = useState('')

    const handleClose = () => {
        setName('')
        setEmail('')
        setPlanName('')
        setWebsite('')
        onClose()
    }

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()

        // Demo only: no API call or database changes
        handleClose()
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            size='lg'
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center fw-bold'>
                        Request New Health Plan
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className='py-4'>
                    <p>
                        Please complete this form. This is a demo
                        request and no message will be sent.
                    </p>

                    <Row className='g-3'>
                        <Col md={6}>
                            <Form.Control
                                type='text'
                                placeholder='Your Name'
                                aria-label='Your Name'
                                value={name}
                                onChange={e => setName(e.target.value)}
                                required
                            />
                        </Col>

                        <Col md={6}>
                            <Form.Control
                                type='email'
                                placeholder='Your Email'
                                aria-label='Your Email'
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                        </Col>

                        <Col md={6}>
                            <Form.Control
                                type='text'
                                placeholder='Health Plan Name'
                                aria-label='Health Plan Name'
                                value={planName}
                                onChange={e => setPlanName(e.target.value)}
                                required
                            />
                        </Col>

                        <Col md={6}>
                            <Form.Control
                                type='url'
                                placeholder='Health Plan Website URL'
                                aria-label='Health Plan Website URL'
                                value={website}
                                onChange={e => setWebsite(e.target.value)}
                            />
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer className='justify-content-end'>
                    <Button
                        variant='outline-primary'
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant='primary'
                        type='submit'
                    >
                        Send Message
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default SuggestHealthPlanModal
